import {useEffect} from "react";

export const COMPANY_SWITCHED_STORAGE_KEY = 'companySwitchedAt'

// The storage event only fires in the other tabs of the same origin, so the tab that switched
// company (and reloads itself) is never reloaded twice.
const useCompanySwitchReload = () => {
    useEffect(() => {
        const reloadOnCompanySwitch = (event) => {
            if (event.key === COMPANY_SWITCHED_STORAGE_KEY && event.newValue) {
                window.location.reload()
            }
        }
        window.addEventListener('storage', reloadOnCompanySwitch)

        return () => {
            window.removeEventListener('storage', reloadOnCompanySwitch)
        }
    }, [])
}

export default useCompanySwitchReload
